module.exports = __webpack_public_path__ + "static/media/ico_story.33095e77.svg";